const transformJobCityToOptions = (
  cityName?: string,
  lat: string | number = '_',
  lng: string | number = '_'
) => {
  const latitude = Number(lat);
  const longitude = Number(lng);
  if (!isNaN(latitude) && !isNaN(longitude) && typeof cityName === 'string') {
    return { nom: cityName, centre: { coordinates: [longitude, latitude] } } as const;
  }
  return undefined;
};

export default transformJobCityToOptions;
